var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MdText"},[_c('vue-markdown',{staticClass:"md",attrs:{"postrender":_vm.handlePostRender,"toc":_vm.toc,"toc-anchor-link":false,"source":_vm.source},on:{"rendered":function (text) { this$1.$emit('rendered', _vm.renderedText) }}}),(_vm.renderedText)?_c('v-runtime-template',{staticClass:"text",attrs:{"template":_vm.renderedText}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }